import React from "react";
import "./terminal-row.css";

function TerminalRowSkeleton() {
  return (
    <div className="tm-row tm-row--skeleton" aria-hidden="true">
      <span className="tm-skeleton-bar tm-skeleton-bar--serial" />
      <span className="tm-skeleton-bar tm-skeleton-bar--merchant" />
      <span className="tm-skeleton-bar tm-skeleton-bar--status" />
      <span className="tm-skeleton-bar tm-skeleton-bar--chevron" />
    </div>
  );
}

export default TerminalRowSkeleton;
